import { types, Instance, SnapshotOut } from "mobx-state-tree";
import api from "services/api/api";

const Coordinates = types.model("coordinates").props({
  coordinates: types.array(types.number),
});

const Model = types.model("ModelResidential").props({
  accumulated: types.maybeNull(types.number),
  battery: types.maybeNull(types.number),
  forwardCumulativeFlow: types.maybeNull(types.number),
  reverseCumulativeFlow: types.maybeNull(types.number),
  id: types.maybeNull(types.string),
  location: types.maybeNull(Coordinates),
  serial: types.maybeNull(types.string),
  connected: types.maybeNull(types.boolean),
  connectedDate: types.maybeNull(types.string),
  group: types.maybeNull(types.string),
  IDMeter: types.maybeNull(types.string),
  averangeConsumption: types.maybeNull(types.number),
});

const Location = types.model("Location").props({
  lat: types.maybeNull(types.number),
  lng: types.maybeNull(types.number),
});

const centerPoint = types.model("CenterPoint").props({
  location: Coordinates,
});

export const ResidentialDeviceModel = types
  .model("device-residential")
  .props({
    alarms: types.optional(types.array(Model), []),
    locationSelected: types.maybeNull(Location),
    idSelected: types.maybeNull(types.string),
    centerPoint: types.maybeNull(centerPoint),
    isLoading: types.boolean,
  })
  .views((self) => ({
    filterValues(value: string | null) {
      if (value === null) return self.alarms;
      return self.alarms.filter(
        (alarm) =>
          alarm?.id?.toLowerCase().includes(value.toLowerCase()) ||
          alarm?.group?.includes(value.toLowerCase()) ||
          alarm?.serial?.toLowerCase().includes(value.toLowerCase())
      );
    },
  }))
  .actions((self) => {
    function setAlarms(alarms: any) {
      self.alarms = alarms;
    }
    function setlocationSelected(cordinates: any) {
      self.locationSelected = cordinates;
    }
    function setId(id: any) {
      self.idSelected = self.idSelected === id ? null : id;
    }
    function setCenter(coordinates: any) {
      self.centerPoint = coordinates;
    }
    function setLoading(isLoading: any) {
      self.isLoading = isLoading;
    }
    return {
      setAlarms,
      setlocationSelected,
      setLoading,
      setCenter,
      setId,
    };
  })
  .actions((self) => ({
    getDevice: async () => {
      try {
        self.setLoading(true);
        const residential = api.residential;
        const response = await residential.getDevice();
        self.setAlarms(response?.answer.device);
        self.setCenter(response?.answer.centerPoint);
        self.setLoading(false);
      } catch (error) {
        console.log(error);
      }
    },
  }));

type ResidentialModelType = Instance<typeof ResidentialDeviceModel>;
type Residential = ResidentialModelType;
type ResidentialSnapshotType = SnapshotOut<typeof ResidentialDeviceModel>;
type ResidentialSnapshot = ResidentialSnapshotType;
export const residentialDefaultModel = () =>
  types.optional(ResidentialDeviceModel, {
    alarms: [],
    locationSelected: null,
    idSelected: null,
    centerPoint: null,
    isLoading: false,
  });
